import { useEffect, useState } from 'react'
import { Regimen } from '../../../../../types/Regimen'

interface CavitationAdjustmentsProps {
  dentalProcedures: Regimen[]
  isSaved: boolean
  cavitations: string
  cavitChecked: string
  dentalItems: { [itemId: string]: string }
}

export const useCavitationAdjustments = ({
  dentalProcedures,
  isSaved,
  cavitations,
  cavitChecked,
  dentalItems,
}: CavitationAdjustmentsProps) => {
  const [adjustedCavitations, setAdjustedCavitations] = useState(cavitations)
  const [hasCavitationAdjustments, setHasCavitationAdjustments] =
    useState(false)

  useEffect(() => {
    if (isSaved && cavitChecked === 'Yes' && dentalProcedures.length > 0) {
      let current = Number(cavitations) || 0
      let hasAdjustment = false

      // Process cavitation procedures
      dentalProcedures.forEach((procedure) => {
        const lastUsage = procedure.usages[procedure.usages.length - 1]
        const procedureId = lastUsage?.fields?.dentalProcedureId
        const procedureName = dentalItems[procedureId]?.toLowerCase() || ''

        // If a cavitation surgery/cleaning procedure is found, reduce the number of cavitations
        if (
          procedureName.includes('cavitation') &&
          (procedureName.includes('surgery') ||
            procedureName.includes('cleaning') ||
            procedureName.includes('removal'))
        ) {
          current = Math.max(0, current - 1)
          hasAdjustment = true
        }
      })

      setAdjustedCavitations(current.toString())
      setHasCavitationAdjustments(hasAdjustment)
    } else {
      // If not saved or cavitChecked is No, use the original values
      setAdjustedCavitations(cavitations)
      setHasCavitationAdjustments(false)
    }
  }, [dentalProcedures, isSaved, cavitations, cavitChecked, dentalItems])

  return {
    adjustedCavitations,
    hasCavitationAdjustments,
  }
}
